import cn from "classnames";
import moment from "moment";
import Tooltip from "rc-tooltip";
import React from "react";

export default function SaveStateFilter(props) {
    if (!props.profile.canSaveReportSnapshot) {
        return null;
    }
    const isPreviousMonth =
        props.values.month === moment().subtract(1, "month").format("MM") && props.values.year === moment().year();
    const toggleFilter = () => {
        props.setFilter({ name: "saveState", value: !props.values.saveState });
    };
    const checkbox = (
        <div className="disabled mb-md-0 report__filters--mr col-form-label-sm cursor-pointer" onClick={toggleFilter}>
            <i
                className={cn("checkbox d-inline-block mr-1", {
                    "checkbox--checked": props.values.saveState,
                    "checkbox--disabled": !isPreviousMonth,
                })}
            />
            Зафиксировать данные
        </div>
    );
    if (isPreviousMonth) {
        return checkbox;
    } else {
        return (
            <Tooltip overlay="Доступно только за предыдущий месяц" placement="top">
                {checkbox}
            </Tooltip>
        );
    }
}
